export const GeneralDropDowns = (data) => {
    return {
      type: 'GeneralDropDowns',
      payload: data
    }
}
